<template>
    <base-popup v-if="enable" @close="closePopup()">
        <v-layout v-if="status == 'init'" row wrap fill-height>

            <v-card width="100%" color="transparent" class="station-card">
                <v-card-title class="d-block pt-0 title">
                    <v-icon size="45" class="d-block"
                            color="primary">
                        mdi-alert-circle-outline
                    </v-icon>
                    <div class="text">
                        {{$vuetify.t("$vuetify.StationLogin.warningMessage")|uppercase}}
                    </div>
                </v-card-title>
                <v-card-text class="text-xs-center body">
                    <v-layout fill-height row wrap align-content-space-between
                              justify-space-between>
                        <v-flex>
                            {{$vuetify.t("$vuetify.StationLogin.message")}}
                        </v-flex>
                        <v-flex>
                            <v-layout>
                                <v-form class="form" ref="form" lazy-validation>
                                    <v-flex xs12>
                                        <v-text-field
                                                autocomplete="new-password"
                                                ref="code"
                                                class="codeField"
                                                v-model="code"
                                                :placeholder="$vuetify.t('$vuetify.StationLogin.codePlaceholder')"
                                                background-color="primary"
                                                color="secondary"
                                                solo
                                                :hide-details="true"
                                                name="code">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-btn block class="eco-button"
                                               color="button-light"
                                               large
                                               type="submit"
                                               @click.prevent="executeLogin()">
                                            {{$vuetify.t('$vuetify.StationLogin.signIn')|uppercase}}

                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs12 v-if="loading">
                                        <v-progress-linear
                                                :indeterminate="true"></v-progress-linear>
                                    </v-flex>
                                </v-form>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-layout>

        <v-layout v-if="status == 'success'" row wrap fill-height>

            <v-card width="100%" color="transparent" class="station-card">
                <v-card-title class="d-block pt-0 title success--text">
                    <v-icon size="45" class="d-block"
                            color="success">
                        mdi-check-circle-outline
                    </v-icon>
                    <div class="text">
                        {{$vuetify.t("$vuetify.StationLogin.goodJobMessage")|uppercase}}
                    </div>
                </v-card-title>
                <v-card-text class="text-xs-center body">
                    <v-layout fill-height row wrap align-content-space-between
                              justify-space-between>
                        <template v-if="station.noMonitorStation">
                            <v-flex>
                                {{$vuetify.t("$vuetify.StationLogin.messageSuccessLoginNoMonitorCode")}}
                            </v-flex>
                            <v-flex xs12>
                              <v-layout fill-height row wrap>
                                <v-flex xs4 class="faxsimil-button">
                                  <div class="round"></div>
                                  <label for="">P1</label>
                                </v-flex>
                                <v-flex xs4 class="faxsimil-button">
                                  <div class="round"></div>
                                  <label for="">P2</label>
                                </v-flex>
                                <v-flex xs4 class="faxsimil-button">
                                  <div class="round"></div>
                                  <label for="">P3</label>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                        </template>
                        <template v-else>
                            <v-flex>
                                {{$vuetify.t("$vuetify.StationLogin.messageSuccessLogin")}}
                            </v-flex>
                            <v-flex class="evidence">
                                <strong>{{$vuetify.t("$vuetify.StationLogin.labelStation")|uppercase}}</strong>
                                {{station.name}}
                            </v-flex>
                            <v-flex>
                                {{$vuetify.t("$vuetify.StationLogin.instructions")}}
                            </v-flex>
                        </template>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-layout>

        <v-layout v-if="status == 'error'" row wrap fill-height>

            <v-card width="100%" color="transparent" class="station-card">
                <v-card-title class="d-block pt-0 title success--text">
                    <v-icon size="45" class="d-block"
                            color="error">
                        mdi-check-circle-outline
                    </v-icon>
                    <div class="text">
                        {{$vuetify.t("$vuetify.StationLogin.warningMessage")|uppercase}}
                    </div>
                </v-card-title>
                <v-card-text class="text-xs-center body">
                    <v-layout fill-height row wrap align-content-space-between
                              justify-space-between>
                        <v-flex>
                            {{$vuetify.t("$vuetify.StationLogin.errorMessage")}}
                        </v-flex>
                        <v-flex>
                            <v-btn block class="eco-button"
                                   color="error"
                                   large
                                   type="submit"
                                   @click.prevent="status='init'">
                                {{$vuetify.t('$vuetify.StationLogin.retry')|uppercase}}

                            </v-btn>

                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-layout>
    </base-popup>
</template>

<script>

    import BasePopup from "./BasePopUp"

    export default {
        data() {
            return {
                code: "",
                status: "init",
                loading: false

            }
        },
        props: {
            station: Object,
            enable: {
                type: Boolean,
                default: false
            }
        },
        components: {
            BasePopup
        },
        methods: {
            closePopup() {
                this.$emit("disable")
            },
            executeLogin() {
                this.loading = true

                const LOGIN_MUTATION = require("../graphql/mutations/stationLogin.gql")
                this.$apollo.mutate({
                    client: "clientPrivate",
                    // Query
                    mutation: LOGIN_MUTATION,
                    // Parameters
                    variables: {
                        code: this.code,
                        station_sgid: this.station.sgid
                    },

                }).then((result) => {
                    this.loading = false

                    result = result.data.codeInsert

                    if (result._response.result) {
                        this.status = "success"
                    } else {
                        this.status = "error"
                    }


                }).catch((error) => {
                    console.log(error)

                    //TODO implementare default error catcher

                })


            }
        }
    }


</script>

<style scoped lang="scss">

    .codeField {

        & /deep/ .v-text-field__slot input{
            text-transform: uppercase !important;
        }

    }

    .station-card {
        box-shadow: none;
        border: none;
        color: var(--v-primary-base);

        .title {
            text-align: center;

            .text {
                color: var(--v-warning-base);
                font-size: 17px;
                margin-top: 10px;
            }
        }

        .body {
            height: 100%;
            height: calc(100% - 130px);

            .form {
                width: 100%;
            }

            .evidence {
                font-size: 27px;
            }
        }
    }

    .faxsimil-button{
      .round{
        $round_size: 60px;
        width: $round_size;
        height: $round_size;
        border-radius: $round_size/2;
        background-color: #c4cece;
        margin: auto;
        margin-bottom: 5px;
      }
    }


</style>